var render, staticRenderFns
import script from "./StarStencil.vue?vue&type=script&lang=js&"
export * from "./StarStencil.vue?vue&type=script&lang=js&"
import style0 from "./StarStencil.vue?vue&type=style&index=0&id=3b51f3c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51f3c4",
  null
  
)

export default component.exports